import React from 'react'
import Calender from './Calender';
import Stats from './Stats';
import './github.css'
const Github = () => {


  return (
    <section className='github' id='github'>
      <Calender />
      <Stats />
    </section>
  );
}

export default Github
